import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import AreaProcessActions from '../../Stores/AreaProcess/Actions';

import AreaList01Table from '../AreaList01/AreaList01Table';

const { TabPane } = Tabs;

class AreaProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchAreaProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchAreaProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchAreaProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchAreaProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/areaProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'AREA_LIST_01' && <AreaList01Table match={match} />}
      </Card>
    );
  }
}

AreaProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchAreaProcess: PropTypes.func
};

AreaProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchAreaProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.areaProcess.process,
  processIsLoading: state.areaProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchAreaProcess: () => dispatch(AreaProcessActions.areaProcessFetchAreaProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AreaProcessScreen));
